import { FC } from 'react'
import cx from 'classnames'

import { FormFieldSelectProps } from '../../form/fields/FormFieldSelect'
import { ActionButtonProps } from '../ActionButton'
import { ProductsFiltersProps } from '../ProductsFilters'
import { ActionButtonVariant } from '../ActionButton/styled'

import * as SC from './styled'

export type SortingFiltersProps = {
  className?: string
  search?: {
    text: string
    results: string
  }
  orderInput?: FormFieldSelectProps
  filterButton?: ActionButtonProps
  filters?: ProductsFiltersProps
}

const SortingFilters: FC<SortingFiltersProps> = ({
  className,
  search,
  orderInput,
  filterButton,
  filters,
}) => {
  return (
    <SC.Wrapper className={cx('SortingFilters', className)}>
      <SC.Top>
        <SC.Search>
          {search && (
            <>
              <SC.SearchText>{search.text}</SC.SearchText>
              <SC.SearchResults>{search.results}</SC.SearchResults>
            </>
          )}
        </SC.Search>
        <SC.Actions>
          {orderInput && <SC.SelectField {...orderInput} />}
          {filterButton && (
            <SC.FilterButton
              {...filterButton}
              variant={ActionButtonVariant.secondary}
            />
          )}
        </SC.Actions>
      </SC.Top>
      {filters && <SC.Filters {...filters} />}
    </SC.Wrapper>
  )
}

export default SortingFilters
